import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { Menu, Links, Modules, Alerts } from 'src/app/interfaces/user';
import { RegisteredEntities } from 'src/app/interfaces/entities';

@Injectable({ providedIn: 'root' })
export class UserInformationService {

  // entitiesList: Lista de entidades que tienen acceso a GC balanced
  entitiesList: RegisteredEntities[];

  // userPermits: Lista de id de páginas a los que tiene permiso el usuario
  userPermits: string[];
  // userNetwork: Red a la que pertenece el usuario
  userNetwork: string;
  // userToken: Id de usuario encriptado
  userToken: string;
  // userLinks: Lista de plataformas a las que tiene acceso el usuario
  userLinks: Links;
  // userName: Nombre del usuario
  userName: string;
  // userType: Tipo de usuario (4): Empleado GC, (2): Entidad
  userType: string;
  // userHome: Página de inicio
  userHome: string;
  // userId: Id de usuario
  userId: string;
  // userAlerts: Listado con alertas de usuario
  userAlerts: Alerts;

  // entityAgreement: Convenio de la entidad
  entityAgreement: string;
  // entityName: Nombre de la entidad
  entityName: string;
  // entityId: Nit de la entidad
  entityId: string;

  // userMenu: Guarda el menú de la aplicación
  userMenu: Menu;

  // platform: Guarda el id de la plataforma GC Balanced
  platform: string;
  // currentPage: Página actual visitada
  currentPage: string;
  // modules: Módulos GC Balanced
  modules: Modules[];

  // shareChanges: Comparte cambios en tiempo real
  emitter: Subject<boolean> = new Subject<boolean>();

}
